import { FC, useRef } from 'react';
import ModalView, { IModalViewProps } from './ModalView';
import type { ModalCloseReason } from '../../types/ModalCloseReason';
import { useModalCloseGuard } from '../../hooks/useModalCloseGuard';

export interface IModalProps extends IModalViewProps {
    /** Проверка черновика перед Escape и кликом снаружи. Крестик закрывает сразу. */
    hasUnsavedInput?: () => boolean;
}

/** Защита локального черновика. Вопрос использует ModalView, чтобы не спрашивать о собственном закрытии
 *  и не создавать циклическую зависимость с useModalCloseGuard. */
const Modal: FC<IModalProps> = ({ onClose, hasUnsavedInput, ...props }) => {
    const closeReason = useRef<ModalCloseReason>('close-button');
    const guard = useModalCloseGuard({
        onClose: () => onClose?.(closeReason.current),
        active: props.opened !== false,
        closeDisabled: props.closeDisabled,
        hasUnsavedInput,
    });
    const requestClose = (reason: ModalCloseReason) => {
        closeReason.current = reason;
        guard.requestClose(reason);
    };

    return (
        <>
            <ModalView {...props} onClose={onClose ? requestClose : undefined} />
            {guard.confirmDialog}
        </>
    );
};

export default Modal;
